import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import { forwardRef } from 'react';
import { CatDrawer } from '@blocks-react/components/Drawer';
import { Conditional } from '../conditional';
import styles from './styles.module.scss';
export const Drawer = forwardRef(({ children, className, preserveContent = false, ...drawerProps }, ref) => (_jsx(CatDrawer, { ...drawerProps, className: cx(styles['drawer'], className), preserveContent: preserveContent, ref: ref, children: _jsx(Conditional, { test: preserveContent || !!drawerProps.isActive, children: children }) })));
